import "./i18n";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import { privateErrorEvent } from "./lib/telemetry-privacy";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import "@/styles/global.css";
import { App } from "./App.tsx";

const sentryDSN = "https://4451eeb9599100837e15934b4b06875c@o4509969344167941.ingest.us.sentry.io/4510047556796416";
Sentry.init({
  dsn: sentryDSN,
  sendDefaultPii: false,
  beforeSend: privateErrorEvent,
  beforeBreadcrumb: () => null
});

// networkMode "always": the browser's online flag is a heuristic (a Mac with
// no default route reports offline while the API on localhost or the clinic
// LAN answers fine), and the default "online" mode parks every query and
// mutation until the flag flips, so a login click sits on "Aguarde por
// favor…" with no request and no error. Sending anyway fails fast with a
// network error the UI can show.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      networkMode: "always",
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      cacheTime: 5 * 60 * 1000,
      retry: 2,
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
    },
    mutations: {
      networkMode: "always",
      retry: false,
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>
);
